const CATEGORIES = [
  { key: "brakes", labelKey: "catBrakes" },
  { key: "filters", labelKey: "catFilters" },
  { key: "suspension", labelKey: "catSuspension" },
  { key: "engine", labelKey: "catEngine" },
  { key: "cooling", labelKey: "catCooling" },
  { key: "electric", labelKey: "catElectric" },
];

export default function CategoryGrid({ t, selectedKey, disabled, onSelect }) {
  return (
    <div>
      <h3 className="text-sm font-mono uppercase tracking-[0.2em] text-slate-600 mb-3">
        {t.categoriesTitle}
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {CATEGORIES.map((c) => {
          const active = c.key === selectedKey;
          return (
            <button
              key={c.key}
              type="button"
              disabled={disabled}
              onClick={() => onSelect(c.key)}
              className={`min-h-[3.5rem] border px-3 py-3 text-left text-xs font-bold uppercase tracking-wide transition-colors ${
                active
                  ? "border-[#0b378c] bg-[#0b378c] text-white"
                  : "border-[#e2e6ec] bg-white text-[#0b1220] hover:border-[#0b378c]"
              } ${disabled ? "opacity-50" : ""}`}
            >
              {t[c.labelKey]}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export { CATEGORIES };
